module.exports = "/_next/static/images/ic_hotel-53f34c32097b99eb2f48ba31627871f3.png";